<template>
    <div>
        <ui-select
            :icon="icon"
            :placeholder="placeholder"
            :label="label"
            :keys="{ label:'title', value: 'id' }"

            :options="options"
            :disabled="isLoading || disabled"
            :invalid="invalid"
            :error="error"
            v-model="selected"
            @change="handleChange"
        ></ui-select>
    </div>
</template>

<script>    
    import { LeadResource } from '../../../classes/Api/Lead'

    export default {
        props: {
            label: {
                type: String,
            },
            placeholder: {
                type: String,
                requred: false,
                default() {
                    return 'Lead'
                }
            },
            value: {
                type: Object,
            },
            invalid: {
                type: Boolean,
                default: false
            },
            error: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                required: false,
            },
            filters: {
                type: Array,
                required: false,
                default() {
                    return []
                }
            },
            relationsToLoad: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    this.selected = newVal;
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: {},
                options: [],
                isLoading: true,
            }
        },
        mounted() {
            this.isLoading = true;

            this.selected = this.value;

            LeadResource.all({ with: this.relationsToLoad, filters: JSON.stringify(this.filters) }).then(response => {
                this.isLoading = false;
                this.options = response.data.results;
            })
        },
        methods: {
            handleChange(e) {
                this.$emit('input', e);
            }
        }
    }
</script>